// Work-item kind for a ticket card — "bug" | "feature" | "story".
//
// Cards carry an explicit `type` in their metadata (CommandService.TicketMeta). Older cards only
// carry the boolean `isBug`, which can't separate a story from a feature — both are "not a bug" —
// which is why the explicit type exists.
//
// For those older cards we fall back to the shape that identifies a story: a feature card always
// carries its TMCHub Issue id, a story never does (it's a bare ProjectTask). That inference is
// gated on `by` — a posted card always names who raised it, whereas ticket-list items (the @tickets
// drawer, search, portfolio) come from TMCHub with only IsBug and no issue id, so inferring there
// would mislabel every feature as a story. Status cards are excluded too: they're keyed on taskId
// for every kind of ticket, so the shape says nothing about the work item's type.
export function ticketType(meta) {
  const t = String(meta?.type || "").toLowerCase();
  if (t === "bug" || t === "feature" || t === "story") return t;
  if (meta?.isBug) return "bug";
  if (meta?.kind !== "status" && meta?.by && !(meta?.issueId > 0) && (meta?.taskId || meta?.id || 0) > 0) return "story";
  return "feature";
}

const LABELS = { bug: "Bug", feature: "Feature", story: "Story" };

export function ticketLabel(metaOrType) {
  const t = typeof metaOrType === "string" ? metaOrType : ticketType(metaOrType);
  return LABELS[t] || "Feature";
}

// Who the byline credits: a bug is reported, a feature requested, a story created.
export function ticketByline(metaOrType) {
  const t = typeof metaOrType === "string" ? metaOrType : ticketType(metaOrType);
  return t === "bug" ? "reported by" : t === "story" ? "created by" : "requested by";
}
